import { Controller } from '@hotwired/stimulus'
import Modal from 'components/modal'

export default class extends Controller {
  initialize(){
    // Automatically open the modal specified in the URL's show_modal_id param.
    // I'm not sure why this functionality is included in this module instead of its own
    // but it was in the onmount component this was migrated from, so I'll keep it for now.
    if(window.location.search && window.location.search.match(/show_modal_id=/)) {
      const matchedId = window.location.search.match(/show_modal_id=([^&]+)/)
      const modalCssId = matchedId[1]
      Modal.show(modalCssId)
    }
  }

  onModalShow(evt) {
    if(!this.isLicenseModal(evt.target)) { return }
    const form = evt.target.querySelector("form")

    // replace the modal's form's continue_to param with the continue_to
    // specified by the button that triggered the modal
    const continueTo = event.detail.trigger.getAttribute("continue-to")
    this.removeContinueToParam(form)
    form.action += ( form.action.match( /[\?]/g ) ? '&' : '?' ) + 'continue_to=' + continueTo
  }

  onModalHide(evt) {
    if(!this.isLicenseModal(evt.target)) { return }
    const form = evt.target.querySelector("form")

    this.removeContinueToParam(form)
  }

  removeContinueToParam(form) {
    form.action = form.action.replace(/\?continue_to\=.*$|continue_to\=.*$|\&continue_to\=.*$/, "")
  }

  isLicenseModal(element){
    return element.matches('.modal-for-licensed-material')
  }
}
